// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2eb2P","detailsBorder":"styles_detailsBorder__2Wpb9"};